export default {
	address: 'Adresse',
	addToCart: 'Ajouter au panier',
	belgium: 'Belgique',
	cart: 'Panier',
	city: 'Ville',
	country: 'Pays',
	currentPage: 'actuelle',
	deliveryDate: 'Date de livraison',
	deliveryFormat: '[Semaine] w YYYY',
	email: 'Email',
	eta: 'ETA:',
	etaFormat: '[Semaine] w',
	firstEta: 'Un ou plusieurs articles de votre panier ne sont actuellement pas en stock. La première semaine de livraison disponible est {{week}}.',
	firstEtaFallback: 'inconnue',
	firstEtaFormat: '[semaine] w',
	friend: 'Qui est-ce que je connais chez PTMD?',
	germany: 'Allemagne',
	itemNotFound: 'Objet non-trouvé',
	itemUnavailable: 'Cet article est actuellement indisponible',
	name: 'Nom',
	netherlands: 'Pays-Bas',
	oops: 'Oops...',
	order: 'Passer la commande',
	orderDetails: 'Détails de la commande',
	phone: 'Numéro de téléphone',
	placeWishlist: 'Placer la liste de souhaits',
	pleaseTilt: 'Veuillez incliner votre appareil.',
	postalCode: 'Code postale',
	stock: 'Stock: {{count}}',
	'stock_interval': '(999999){Stock: Bientôt disponible};',
	thanksForYourOrder: 'Merci pour votre commande Click & Collect. Votre liste de souhaits va maintenant être envoyée à {{customer}}. {{customer}} vous contactera dès que possible.',
	toggleFullScreen: 'Basculer en plein écran',
	total: 'Total:',
	useSafari: 'Veuillez utiliser Safari comme navigateur.',
	yourShop: 'Votre magasin: {{customer}}'
};
